var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0907 11.875C18.0907 14.9356 15.6096 17.4167 12.5491 17.4167C9.48847 17.4167 7.00739 14.9356 7.00739 11.875C7.00739 8.81442 9.48847 6.33333 12.5491 6.33333C15.6096 6.33333 18.0907 8.81442 18.0907 11.875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9241 11.875C33.9241 14.9356 31.443 17.4167 28.3824 17.4167C25.3218 17.4167 22.8407 14.9356 22.8407 11.875C22.8407 8.81442 25.3218 6.33333 28.3824 6.33333C31.443 6.33333 33.9241 8.81442 33.9241 11.875Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0907 27.7083C18.0907 30.7689 15.6096 33.25 12.5491 33.25C9.48847 33.25 7.00739 30.7689 7.00739 27.7083C7.00739 24.6477 9.48847 22.1667 12.5491 22.1667C15.6096 22.1667 18.0907 24.6477 18.0907 27.7083Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9241 27.7083C33.9241 30.7689 31.443 33.25 28.3824 33.25C25.3218 33.25 22.8407 30.7689 22.8407 27.7083C22.8407 24.6477 25.3218 22.1667 28.3824 22.1667C31.443 22.1667 33.9241 24.6477 33.9241 27.7083Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu4);
export default __webpack_public_path__ + "static/media/Menu-4.50c88bdb3b84e5985a45ec7cfc7303cf.svg";
export { ForwardRef as ReactComponent };